import PlayersMenu from "components/Player/PlayersMenu";
import TimeLeft from "components/General/TimeLeft";
import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"
import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";
import HostVoteView from "components/Host/HostVoteView";
import Timer from "components/Timer";
import GameControls from "components/Host/GameControls";
import GameInfoTab from "components/Host/GameInfoTab";
import Map from "components/Map/Map";

import Chat from "components/Chat/Chat";
import ChatRoom from "components/Chat/ChatRoom";

import HostBank from "components/Host/HostBank";

import React,{
  useState,
  useEffect,
} from "react";

const HostGameView: React.FC = () => {
  const { 
    gameId,
    connectedIds,
    timeLeft,
    roleGroupDataHistory,
    currentStage,
    proposalHistory,

    hostIsPlaying,
  } = useGameContext();

  console.log("SDF");
  console.log("SDF");
  console.log(proposalHistory);

  const navigate = useNavigate()

  const { socket } = useWebSocket();
  // TODO If you're here and you're not admin then get kicked out

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!gameId) {
      navigate("/play");
    }
  }, [gameId])

  const [currentTab, setCurrentTab] = useState("Info");
  const [chatRoomId, setChatRoomId] = useState("");

  const tabs = [
    "Info",
    "Map",
    "Settings",
    "Voting",
    "Players",
    "Chats",
    "Money",
  ]

  return (
    <div className="flex flex-col h-[100vh] w-[100vw]">
      <div className="flex flex-col p-2">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row gap-4">
            <h1 className="text-2xl">Host Controls</h1>
            { hostIsPlaying && (
              <BasicButton
                text={"Back to game"}
                onClick={() => {
                  if (currentStage === "vote") {
                    navigate("/play/main/vote")
                    return
                  }
                  navigate("/play/main")
                }}
              />
            )}
          </div>

          <p className="capitalize text-xl">Current {currentStage} <TimeLeft time={timeLeft}/></p>
        </div>
        <div className="flex flex-row pt-4">
          {tabs.map((tab, i) => (
            <div className="flex flex-row" key={i}>
              <div className="border-b border-black w-1"/>
              <button
                className={`px-2 py-1 border-x border-t ${ tab === currentTab ? "bg-opacity-0" : "bg-opacity-10 border-b"} border-black bg-black`}
                onClick={() => setCurrentTab(tab)}
              >{tab}</button>
              <div className="border-b border-black w-1"/>
            </div>
          ))}
          <div className="border-b border-black w-full flex"/>
        </div>
      </div>

      { ( currentTab === "Info" ) ? (
        <GameInfoTab />
      ) : (currentTab === "Map" && gameId ) ? (
        <Map
          showFullMap={true}
          enableTools={false}
          showAnimals={true}
          tutorialWindows={{} as Record<string, { open: boolean; firstOpened: boolean }>}
          toggleTutorialWindow={() => {}}
          getTutorialWindowState={() => ({ open: false, firstOpened: false })}
        />
      ) : (currentTab === "Settings") ? (
          <GameControls />
      ) : ( currentTab === "Voting") ? (
        <HostVoteView />
      ) : ( currentTab === "Players") ? (
        <div className="px-4">
          <PlayersMenu />
        </div>
      ) : ( currentTab === "Money") ? (
        <div className="px-4">
          <HostBank/>
        </div>
      ) : ( currentTab === "Chats") ? (
        <div className="h-full w-full px-4 p-4 flex flex-row gap-4">
          <div className="w-[20%]">
            <Chat
              onRoomClick={(roomId: string) => {
                setChatRoomId(roomId);
              }}
            />
          </div>

          { chatRoomId && (
            <ChatRoom
              onBackClick={()=>null}
              roomId={chatRoomId}
            />
          )}
        </div>
      ) : (
        <></>
      )}




    </div>
  );
};

export default HostGameView;
